import _ from 'lodash';
import moment from 'moment';
import { observable, computed, action } from 'mobx';

import lectureFixtures from './fixtures/lectures';


export class LecturesStore {
  _lectures$ = observable.array(null);
  _activeTagFilter$ = observable.array([]);
  sortingAvailable$ = observable.array(['date', 'fee', 'seats', 'title']);

  @computed
  get lectures$() {
    if (!this._lectures) {
      this.loadLectures();
    }

    return this._lectures$;
  };

  @action
  loadLectures() {
    this._lectures$ = this.annotate(lectureFixtures);
  }

  @action
  addTagFilter(value) {
    this._activeTagFilter$.push(value);
  }

  @computed
  get options$() {
    return this.tags$.map((tag) => {
      return { value: tag, label: tag }
    });
  }

  @computed
  get tags$() {
    let tags = [];
    this.lectures$.forEach((lecture) => tags = [...tags, ...lecture.tags]);
    return _.uniq(tags);
  }

  annotate(lectures) {
    return lectures.map((lecture) => {
      const lect = JSON.parse(JSON.stringify(lecture));

      if (lect.date !== null) {
        const date = moment(lecture.date);
        const now = moment();
        if (date.isBefore(now)) {
          lect.date = null;
        }
      }

      return lect;
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/lectures/lecture.store.js